import { BlockContent, BlockType } from '../types/WorkspaceOverviewTypes';

export const parseMarkdownToBlockContent = (markdown: string, blockType: BlockType): BlockContent => {
  switch (blockType) {
    case 'text':
    case 'textarea':
    case 'rich_text':
      return { value: markdown };

    case 'quote': {
      const value = markdown
        .split('\n')
        .map(line => line.replace(/^>\s?/, ''))
        .join('\n')
        .trim();
      return { value };
    }

    case 'callout': {
      const match = markdown.match(/^\*\*\[(\w+)\]\*\*\s*([\s\S]*)/);
      if (match) {
        const variant = match[1].toLowerCase() as BlockContent['variant'];
        return { value: match[2].trim(), variant };
      }
      return { value: markdown };
    }

    case 'code': {
      const match = markdown.match(/^```(\w*)\n([\s\S]*?)\n```$/s);
      if (match) {
        return { value: match[2], language: match[1] || undefined };
      }
      return { value: markdown.replace(/^```\w*\n?|\n?```$/g, '') };
    }

    case 'list': {
      const items = markdown
        .split('\n')
        .filter(line => line.trim().startsWith('- '))
        .map(line => line.replace(/^-\s+/, '').trim());
      return { items };
    }

    case 'checklist': {
      const lines = markdown
        .split('\n')
        .filter(line => /^-\s+\[[ xX]\]/.test(line.trim()));
      const items = lines.map(line => line.replace(/^-\s+\[[ xX]\]\s*/, '').trim());
      const checked = lines.map(line => /^-\s+\[[xX]\]/.test(line.trim()));
      return { items, checked };
    }

    case 'links': {
      const urls = markdown
        .split('\n')
        .filter(line => line.trim().startsWith('- '))
        .map(line => {
          const linkMatch = line.replace(/^-\s+/, '').trim().match(/^\[(.+?)\]\((.+?)\)$/);
          if (linkMatch) {
            return { label: linkMatch[1], url: linkMatch[2] };
          }
          const bare = line.replace(/^-\s+/, '').trim();
          return { label: bare, url: bare };
        });
      return { urls };
    }

    case 'link': {
      const match = markdown.trim().match(/^\[(.+?)\]\((.+?)\)$/);
      if (match) {
        return { url: match[2], label: match[1] };
      }
      return { url: markdown.trim(), label: markdown.trim() };
    }

    case 'group':
      // Read-only — return unchanged to avoid accidental data loss
      return {};

    default:
      return { value: markdown };
  }
};
